import React from "react";
import { Modal, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

interface Props {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}

const DeleteConfirmationModal: React.FC<Props> = ({
  visible,
  onCancel,
  onConfirm,
  title = "Delete Document",
  message = "Are you sure you want to delete this document?",
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      centered
      closable={false}
      width="80%"
      bodyStyle={{
        borderRadius: "20px",
        padding: "20px",
        textAlign: "center",
      }}
      style={{ zIndex: 10000 }}
    >
        <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px solid red",
                  borderRadius: "50%",
                  padding: "6px",
                  boxShadow: "0 24px 24px rgba(0, 0, 0, 0.15)",
                  backgroundColor: " #ffffff",
                  marginBottom: "8px",
                }}
              >
                <DeleteOutlined style={{ fontSize: "14px", color: "red" }} />
              </div>
      <h3 style={{ margin: 0, fontSize: 12, marginBottom: 10 }}>{title}</h3>
      <p style={{ fontSize: 10, marginBottom: 10 }}>{message}</p>
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <Button
          onClick={onCancel}
          style={{
            borderRadius: 12,
            padding: "4px 8px",
            fontSize: 10,
          }}
        >
          <span style={{fontSize: 10}}>Cancel</span>
        </Button>
        <Button
          type="primary"
          danger
          onClick={onConfirm}
          style={{
            borderRadius: 12,
            padding: "4px 8px",
            fontSize: 10,
          }}
        >
          <span style={{fontSize: 10}}>Delete</span>
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;